export default __webpack_public_path__ + "static/media/contact_search.ca311051.svg";